function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { MapPinElement, Circle, Triangle, TextElement, NumberElement } from './elements';
import { Icon } from '../Icon';
import { StateLayer } from '../../core-components';
export const MapPin = /*#__PURE__*/forwardRef(({
  size = 'medium',
  variant = 'logo',
  isSelected = false,
  ariaLabel,
  color = 'primary',
  label,
  ...rest
}, fRef) => {
  const isIconVariant = variant === 'user' || variant === 'logo';
  const iconSize = {
    small: '1.0625rem',
    medium: '1.6875rem'
  }[size];
  let content;
  if (variant === 'logo') {
    content = /*#__PURE__*/React.createElement(Icon.SSR, {
      size: iconSize,
      src: "asurion-logo"
    });
  } else if (variant === 'number') {
    content = /*#__PURE__*/React.createElement(NumberElement, {
      $size: size
    }, label);
  } else if (variant === 'user') {
    content = /*#__PURE__*/React.createElement(Icon.SSR, {
      size: iconSize,
      src: "notification-status-dot-circle-indicator"
    });
  } else if (variant === 'text') {
    content = /*#__PURE__*/React.createElement(TextElement, {
      $size: size
    }, label);
  }
  return /*#__PURE__*/React.createElement(MapPinElement, _extends({
    ref: fRef,
    "aria-label": ariaLabel || isIconVariant && 'Map pin' || label,
    $pinVariant: variant,
    $color: color,
    $size: size,
    $selected: isSelected,
    $label: label
  }, rest, {
    "data-aui": "map-pin"
  }), /*#__PURE__*/React.createElement(Circle, {
    $pinVariant: variant,
    $color: color,
    $size: size
  }, /*#__PURE__*/React.createElement(StateLayer, null), content), /*#__PURE__*/React.createElement(Triangle, {
    $color: color,
    $size: size
  }, /*#__PURE__*/React.createElement(StateLayer, null)));
});